import React, { useState, useEffect } from "react";
import { setKey, setStringifiedKey, clearKeys } from "../store/actions";
import { connect } from "react-redux";
import { Link, NavLink, Redirect } from "react-router-dom";
import userService from "../services/user";
import utils from "../utils/utils";
import keys from "../store/keys";
import Cookies from 'universal-cookie';

function Login({ session, setKey, clearKeys, setStringifiedKey, ...props }) {

	const [email, setEmail] = useState('');
	const [password, setPassword] = useState('');
	const [rememberMe, setRememberMe] = useState(true);
	const [errorMessage, setErrorMessage] = useState('');
	const [successMessage, setSuccessMessage] = useState('');
	const [redirectTo, setRedirectTo] = useState(null);

	useEffect(() => {
		if (session.isLoggedIn) {
			setRedirectTo("/");
		}
		else {
			clearKeys();
		}
	}, []);

	const handleSubmit = e => {
		e.preventDefault();
		if (!email || email.length === 0) {
			setErrorMessage(`Email address is required.`);
			return;
		} else {
			if (!utils.isValidEmail(email)) {
				setErrorMessage(`Please provide a valid email address.`);
				return;
			}
		}
		if (!password || password.length === 0) {
			setErrorMessage(`Password is required.`);
			return;
		}

		setKey(keys.isLoading, true);
		userService.login(email, password)
			.then(result => {
				if (result.error) {
					setErrorMessage(result.error);
					setKey(keys.isLoading, false);
					return;
				}

				const data = result.data;
				setErrorMessage('');
				setSuccessMessage(`Login successful! Redirecting...`);

				const cookies = new Cookies();
				if (rememberMe)
					cookies.set(data.cookie, data.token, { path: '/', maxAge: data.age });
				else
					cookies.remove(data.cookie);

				setKey(keys.token, data.token);
				setKey(keys.isLoading, false);
				setKey(keys.cookie, data.cookie);
				setKey(keys.isLoggedIn, true);
				setStringifiedKey(keys.user, data.user);
				setKey(keys.showLogin, false);
				setRedirectTo('/');
			});
	}

	return (
		<>
			{redirectTo && <Redirect push to={redirectTo} />}
			<div className="container container-small">
				<h4 className="mt-50">Sign in</h4>
				<form onSubmit={handleSubmit}>
					<div className="form-group mt-20 mb-3">
						<label htmlFor="txtEmail" className="form-label">
							Email address
						</label>
						<input
							className="form-control shadow-none"
							type="email"
							placeholder="johndoe@gmail.com"
							required="required"
							id="txtEmail"
							value={email}
							onChange={e => setEmail(e.target.value)}
						/>
					</div>
					<div className="form-group mb-2">
						<label htmlFor="txtPassword" className="form-label">
							Password
						</label>
						<input
							className="form-control shadow-none"
							type="password"
							placeholder="*******"
							required="required"
							id="txtPassword"
							value={password}
							onChange={e => setPassword(e.target.value)}
						/>
					</div>
					<div className="row mt-10 mb-10">
						<div className="col">
							<NavLink to="/fp" className="btn btn-link">
								Forgot your password?
							</NavLink>
						</div>
					</div>
					<div className="row">
						<div className="col">
							{errorMessage && <div className="text-danger mb-2">{errorMessage}</div>}
							{successMessage && <div className="text-success mb-2">{successMessage}</div>}
						</div>
					</div>
					<div className="row mb-30">
						<div className="col">
							<button
								type="submit"
								className="btn btn-dark shadow-none w-100 mt-10 mb-3"
								onClick={handleSubmit}>
								Sign In
							</button>
						</div>
					</div>
					<hr />
					<div className="row text-center mt-30">
						<div className="col">
							<p>Don't have account?</p>
							<NavLink to="/signup" className="btn btn-outline-dark mt-10 w-100">
								Create Account
							</NavLink>
						</div>
					</div>
				</form>
			</div>
		</>
	);
}

const mapStateToProps = (store) => ({ session: store.session });
const mapDispatchToProps = (dispatch) => ({
	setKey: (key, value) => dispatch(setKey(key, value)),
	clearKeys: () => dispatch(clearKeys()),
	setStringifiedKey: (key, value) => dispatch(setStringifiedKey(key, value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
